import adminApiFetch from './apiService';

const consumableService = {
  // 獲取耗材列表（用於搜尋）
  fetchList: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.limit) queryParams.append('limit', params.limit);

    const res = await adminApiFetch(`consumables?${queryParams.toString()}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 獲取耗材列表（用於表格）
  getRecords: async (params = {}) => {
    const res = await adminApiFetch('consumables/get_records', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取所有耗材 ID（用於篩選）
  getIds: async (params = {}) => {
    const res = await adminApiFetch('consumables/get_ids', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取單個耗材
  get: async (id) => {
    const res = await adminApiFetch(`consumables/${id}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 獲取單個耗材（別名）
  getById: async (id) => {
    return consumableService.get(id);
  },

  // 創建耗材
  create: async (data) => {
    const res = await adminApiFetch('consumables', {
      method: 'POST',
      body: { consumable: data }
    });
    return res.json();
  },

  // 更新耗材
  update: async (id, data) => {
    const res = await adminApiFetch(`consumables/${id}`, {
      method: 'PUT',
      body: { consumable: data }
    });
    return res.json();
  },

  // 刪除耗材
  delete: async (id) => {
    const res = await adminApiFetch(`consumables/${id}`, {
      method: 'DELETE'
    });
    return res.json();
  },

  // 檢查條碼是否可用
  checkBarcode: async (barcode) => {
    const res = await adminApiFetch(`consumables/check_barcode?barcode=${encodeURIComponent(barcode)}`, {
      method: 'GET'
    });
    return res.json();
  }
};

export { consumableService };
export default consumableService;
